import useMediaQuery from '@mui/material/useMediaQuery'
import { default as cx } from 'classnames'
import { styles } from './styles/side-scroll'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

interface SidescrollProps {
  children: ReactNode
  className?: string
  conditionalySidescroll?: boolean
  maxWidth?: string
  fixMaxContentForApple?: boolean
  [key: string]: any
}

const Sidescroll = ({
  children,
  className,
  conditionalySidescroll = false,
  maxWidth = '768px',
  fixMaxContentForApple,
  ...props
}: SidescrollProps) => {
  const isSmallDisplay = useMediaQuery(`(max-width: ${maxWidth})`)

  const shouldScroll = !conditionalySidescroll || isSmallDisplay

  return (
    <Box
      sx={{
        width: '100%',
        ...(shouldScroll ? styles.scrollableContainer : {}),
      }}
      className={className}
      {...props}
    >
      <Box
        sx={{
          ...(fixMaxContentForApple ? { width: '100%' } : {}),
          ...(shouldScroll ? styles.scrollable : {}),
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default Sidescroll
